import './IntegrationDisconnectModal.scss';
import ModalTemplate from 'components/ModalTemplate';
import { func } from 'prop-types';

export const INTEGRATION_DISCONNECT_MODAL_ID = 'IN';

const IntegrationDisconnectModal = ({ handleClose }) => {
  return (
    <ModalTemplate
      modalBtnClass='integrations_page_disconnect_button'
      modalTitle='Disconnect?'
      modalTitleAlign='center'
      modalBtnText='Yes, disconnect'
      modalBtnAction={() => {}}
      modalBtnDisabled={false}
      modalClose={handleClose}
      modalBtnLoading={false}
      modalContent={<>ok</>}
    />
  );
};

IntegrationDisconnectModal.propTypes = {
  handleClose: func.isRequired
};

export default IntegrationDisconnectModal;
